import { createContext, useContext } from 'react'

export const FieldContext = createContext<{
  id?: string
  invalid?: boolean
  errorId?: string
}>({})
export function useFieldControl() {
  return useContext(FieldContext)
}
